import { Row, Form, Checkbox, Anchor, DatePicker } from "antd";
import { forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import { update_verificationslist_form } from "../../actions/form_slice";
import { debounce } from "lodash";

const { Link } = Anchor;

const VERIFICATIONSLIST = forwardRef(({ onValuesChange }, ref) => {
  const [form] = Form.useForm();

  useImperativeHandle(ref, () => ({
    getFieldsError: form.getFieldsError,
    validateFields: form.validateFields,
    resetFields: form.resetFields,
    setFieldsValue: form.setFieldsValue,
    submit: form.submit,
    getFieldsValue: form.getFieldsValue,
  }));

  const dispatch = useDispatch();
  const formData = useSelector(
    (state) => state.form.verificationslist_form_type
  );

  const handleFormChange = debounce((changedValues) => {
    dispatch(update_verificationslist_form(changedValues));
    onValuesChange(formData);
  }, 300);

  return (
    <Form
      form={form}
      onValuesChange={handleFormChange}
      // onFinish={props.onFinish}
      labelAlign="justify"
      layout="horizontal"
      labelWrap
      //   wrapperCol={{
      //     flex: 1,
      //   }}
    >
      <Form.Item
        valuePropName="checked"
        name="Sent KEES request for verification from Document Control (desk aid)"
      >
        <Checkbox value="Sent KEES request for verification from Document Control (desk aid)">
          Sent KEES request for verification from Document Control{" "}
          {
            <a
              href="http://dcfnet.dcf.ks.gov/EES/Documents/KEESP3TrainingResources/DeskAids/Verification Detail Type Desk Aid.pdf"
              target="_blank"
            >
              (desk aid)
            </a>
          }
        </Checkbox>
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="Verification List Page completed, Program is selected, and Notice Sent. (V000)"
      >
        <Checkbox value="Verification List Page completed, Program is selected, and Notice Sent. (V000)">
          Verification List Page completed, Program is selected, and Notice
          Sent. (V000)
        </Checkbox>
      </Form.Item>
      <Row style={{ marginBottom: 10 }}>
        <label>*Check Distributed Documents to ensure notice sent*</label>
      </Row>
      <Form.Item name="Due Date" label="Due Date">
        <DatePicker
          style={{ width: "100%", color: "#000000" }}
          allowClear
          format={"YYYY-MM-DD"}
        />
      </Form.Item>
    </Form>
  );
});
export default VERIFICATIONSLIST;
